module.exports = __webpack_public_path__ + "img/zl_sj_bg.74a63b2f.png";